export const base_url = "https://medicotoon.com/medicotoon/backend";
